import { ids } from "@icarros/theme-react";
import styled, { css } from "styled-components";
import { Contrast } from "../../../types/general.types";
import { ShimmerVariants } from "./constants";
const { color, size } = ids || {};
// const circleSpinAnimation = css`
//   @keyframes circleSpin {
//     from {
//       transform: translate(var(--spin-value), var(--spin-value)) rotate(0deg);
//     }
//     to {
//       transform: translate(var(--spin-value), var(--spin-value)) rotate(360deg);
//     }
//   };
// `;
const defaultStyle = css `
  background-image: ${color.background_shimmer.ids_color_bg_shimmer_gradient};
`;
const onDark = css `
  background-image: ${color.background_shimmer
    .ids_color_bg_shimmer_gradient_onDark};
`;
const onLight = css `
  background-image: ${color.background_shimmer
    .ids_color_bg_shimmer_gradient_onLight};
`;
const getShimmerContrastStyle = (contrast) => {
    switch (contrast) {
        case Contrast.dark:
            return onDark;
        case Contrast.light:
            return onLight;
        default:
            return defaultStyle;
    }
};
export const StyledShimmer = styled.div `
  @keyframes shimmer {
    from {
      background-position-x: 200%;
    }

    to {
      background-position-x: 0%;
    }
  }

  animation: shimmer 1000ms ease infinite;

  background-size: 200%;
  border-radius: ${size.general.ids_size_general_8x};
  display: block;
  overflow: hidden;
  position: relative;
  height: ${({ height }) => height !== null && height !== void 0 ? height : size.general.ids_size_general_24x};
  width: ${({ width, height, variant }) => variant === ShimmerVariants.square
    ? height !== null && height !== void 0 ? height : size.general.ids_size_general_24x
    : width !== null && width !== void 0 ? width : size.general.ids_size_general_100x};
  ${({ contrast }) => getShimmerContrastStyle(contrast)};
  > * {
    visibility: hidden;
  }
`;
//# sourceMappingURL=Shimmer.style.js.map